
import { mdiRadioboxMarked, mdiRadioboxBlank } from '@mdi/js'
import { mapMutations, mapState, mapGetters, mapActions } from 'vuex'
import { sleep } from '../lib/helpers'

export default {
  name: 'Test',
  data: () => ({
    mdiRadioboxBlank,
    mdiRadioboxMarked
  }),
  head: () => ({
    title: 'Testul'
  }),
  computed: {
    ...mapState(['test', 'development', 'form', 'loading']),
    ...mapGetters(['GET_CURRENT_QUESTIONS', 'GET_PROGRESS', 'NEXT_BUTTON_STATE', 'BACK_BUTTON_STATE', 'GET_CURRENT_ANSWER'])
  },
  watch: {
    'test.done': async function (testDone) {
      if (testDone) {
        this.$confetti.start({ particlesPerFrame: 0.25, particles: [{ type: 'heart' }] })
        await sleep(4000)
        this.$confetti.stop()
      }
    }
  },
  mounted () {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const dealId = urlParams.get('dealId');
    const simpleId = urlParams.get('id');
    console.log(dealId);
    if (dealId) {
      localStorage.setItem('dealId', dealId);
    } else {
      if (simpleId) {
        localStorage.setItem('dealId', simpleId);
      }
    }

    this.onResize()
    this.$amplitude.getInstance().logEvent('b5.test', { part: 'start' })
  },
  created () {
    this.SET_INVENTORY()
  },
  methods: {
    ...mapMutations(['SET_INVENTORY', 'SET_ANSWER', 'NEXT_QUESTIONS', 'PREVIOUS_QUESTIONS', 'SET_ITEMS_PER_PAGE', 'SKIP_QUESTIONS']),
    ...mapActions(['SUBMIT_TEST']),
    onResize () {
      window.innerWidth < 600
        ? this.SET_ITEMS_PER_PAGE(1)
        : this.SET_ITEMS_PER_PAGE(3)
    }
  }
}
